export const routes = {
  portal: '/',
  confirmEmail: '/sign-up/confirm-email',
  setPassword: '/sign-up/set-password',
  linkExpired: '/link-expired',
  storybook: '/storybook',
  profile: '/profile',
  login: '/login',
  loginOld: '/login-old',
  userNotExist: '/user-not-exist',
  settings: '/settings',
  dashboard: '/dashboard',
  compliance: '/compliance',
  contracts: '/contracts',
  myContracts: '/my_contracts',
  bidding: '/bidding',
  vendors: '/vendors',
  chat: '/chat',
  resetPassword: '/reset-password',
  createUserProfile: '/my-community/profile',
  rfp: '/rfp',
  notFound: '/404',
  productRequests: '/product-requests',
  financials: '/financials',
  purchaseOrders: '/purchase-orders',
  invoiceData: '/invoice-data',
  faNumber: '/fa-phone-number',
  faCode: '/fa-code',
  termsOfUse: '/terms-of-use',
  privacyPolicy: '/privacy-policy',
  landing: '/landing',
  onboarding: '/onboarding',
  clinicalReview: '/clinical-review',
  cognusRepository: '/cognus_repository',
  centralRepository: '/central_repository',
  opportunityAnalysis: '/opportunity_analysis',
  calendar: '/calendar',
  contractPipeline: '/contract_pipeline',
  myCommunity: '/my-community',
  myOrganization: '/my_organization',
  bankAccounts: '/bank_accounts',
  vendorDetails: '/vendor-details',
  bulkContractCreation: '/bulk_contract_creation',
  verifyEmail: '/verify-email',
  pendingApproval: '/pending-approval',
  healthSystem: '/health-system',
  marketInsights: '/market-insights',
  completeProfile: '/complete-profile',
  selfSignUp: '/self-sign-up/confirm-email',
  contractCategories: '/contract_categories',
  addBusinessDetails: '/add_business_details',
  addBankAccount: '/add_bank_account',
  hospitals: '/hospitals',
  paymentDetails: '/payment_details',
  gpo: '/gpo',
  additionalValues: '/additional-values',
  savingGoals: '/saving-goals',
  healthSystems: '/health_systems'
} as const
